import React, { FC, useRef } from 'react';
import { Modal } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import { ymPushParams } from 'utils/ym';

import { TBuySimModal } from './types';
import { ChooseSimType } from './components/ChooseSimType';
import { DesktopESimInstruction } from './components/DesktopESimInstruction';
import { useChooseSimType } from './hooks/useChooseSimType';
import { getModalClicksAnalytics } from './utils/getModalClicksAnalytics';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

// BCNC-7422: Временная модалка с покупкой сим вместо перехода на конструктор тарифа
export const BuySimModal: FC<TBuySimModal> = ({
  isOpen,
  onClose,
  buyModalContent: { title, desktopESimInstruction, variants },
  tariffInfo,
}) => {
  const modalRef = useRef(null);
  const {
    onClickSim,
    onClickESim,
    isShowEsimInstruction,
    setIsShowEsimInstruction,
    isDisabled,
    eSimOrderTariffLink,
  } = useChooseSimType(tariffInfo, title);

  return (
    <Modal
      closeOptions={{ button: true, overlay: true, escape: true }}
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setIsShowEsimInstruction(false);
        ymPushParams(
          getModalClicksAnalytics({
            item_type: 'icon',
            icon_name: 'close',
            popup_title: title,
          }),
        );
      }}
    >
      <div className={cx('wrapper')} ref={modalRef}>
        {isShowEsimInstruction ?
          <DesktopESimInstruction {...desktopESimInstruction} />
        : <ChooseSimType
            esimHref={eSimOrderTariffLink}
            isDisabled={isDisabled}
            onClickESim={onClickESim}
            onClickSim={onClickSim}
            title={title}
            variants={variants}
          />
        }
      </div>
    </Modal>
  );
};
